
import { LoadingButton } from '@mui/lab';
import { Box, Dialog, DialogActions, DialogContent, Grid } from '@mui/material';
import { useEffect, useState } from 'react'
import { FieldValues, useForm } from 'react-hook-form';
import AppAutoComplete from '../../../Component/Common/Components/FormValidationInputs/AppAutoComplete';
import { StaticDataModel } from '../../../Component/Model/Dto/StaticData';
import { CustomDialogTitle } from '../../Common/Custom/CustomDialogTitle';
import { yupResolver } from '@hookform/resolvers/yup';
import { OrgnaisationLinkScorecardValidationSchema } from './OrganisationLinkScorecardValidationSchema';
import { OrganisationLinkedScorecardService } from '../../../Component/Api/Organisation/OrganisationLinkedScorecardService';
import { toast } from 'react-toastify';
import { OrganisationLinkedScorecard } from '../../../Component/Model/Dto/Organisation/OrganisationLinkedScorecard';
import { LongTableDateHelper } from '../../../Component/Model/helpers';
import { SmallLoading } from '../../../Component/Common/Components/Loading/IntermediateLoading';

interface IProps {
    openModal: boolean;
    organisationId: number;
    handleClose: () => void;
}

export const OrganidationLinkedScorecardModal = (props: IProps) => {
    const [scorecards, setScorecards] = useState<StaticDataModel[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { control, handleSubmit, formState: { isSubmitting } } = useForm({
        mode: 'all',
        resolver: yupResolver(OrgnaisationLinkScorecardValidationSchema)
    });

    const handleLinkScorecard = async (data: FieldValues) => {
         const scorecardToLink: OrganisationLinkedScorecard.Dto = {
            scorecardId: data.scorecard.Id,
            organisationId: props.organisationId
        };
        try {
            const result = await OrganisationLinkedScorecardService.LinkScorecard(scorecardToLink);
            toast.success("Scorecard linked successfully");
        } catch (error) {
            console.log(error)
        }
        finally{
            props.handleClose();
        }
    }

    const getScorecardsToLink = async () => {
        try {
            setIsLoading(true);
            const response = await OrganisationLinkedScorecardService.GetAllScorecardsToLink(props.organisationId);
            if(response.data && response.data.length > 0){
                const mappedData: StaticDataModel[] = response.data.map(x => ({
                    Id: x.scorecardId,
                    Name: `${x.isEEScorecard ? '| EE |' : '| BEE |'} ${x.scorecardName} (${LongTableDateHelper(x.startDate)} - ${LongTableDateHelper(x.endDate)})`
                }));
                setScorecards(mappedData);
            }
            else{
                setScorecards([]);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getScorecardsToLink();
    }, [])


    return (
        <>

            <Dialog disableEnforceFocus open={props.openModal} onClose={() => { props.handleClose()}} aria-labelledby="form-dialog-title" maxWidth='md' fullWidth>
                <CustomDialogTitle id="customized-dialog-title" onClose={() => props.handleClose()} rightMargin={"50px"}>
                    Link Scorecard
                </CustomDialogTitle>
                <DialogContent>
                    {isLoading ? <SmallLoading></SmallLoading> :
                        <Box>
                            <form id='ScorecardLinkSelectionForm' onSubmit={handleSubmit(handleLinkScorecard)}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={12} mt={1}>
                                        <AppAutoComplete control={control} name="scorecard" label="Scorecards" options={scorecards} size={"small"} limit={1000} />
                                    </Grid>
                                </Grid>
                            </form>
                        </Box>
                    }
                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={isSubmitting} variant='contained' type="submit" form='ScorecardLinkSelectionForm' color='primary'>Link</LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}
